export const APP_VERSION = '1.0.2';

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const WS_API_BASE_URL = process.env.REACT_APP_WS_API_BASE_URL;
export const API_PREFIX = process.env.REACT_APP_API_PREFIX;

export const API_URL = API_BASE_URL + API_PREFIX;
export const WS_URL = WS_API_BASE_URL;